import { Injectable } from '@angular/core';
import * as signalR from "@aspnet/signalr";
import { Constants } from '../constants/constants';

@Injectable({
  providedIn: 'root'
})
export class SignalRService {

  private hubConnection: signalR.HubConnection

  interval:any;

  constructor() { }

  public startConnection = () => {

    

    this.hubConnection = new signalR.HubConnectionBuilder()
                            .withUrl(Constants.ROOT_URL+Constants.URL_SIGNALR)
                            .build();
 
    this.hubConnection
      .start()
      .then(() => {
        console.log('Connection started');
        let infoUsuario = JSON.parse(sessionStorage.getItem("infoUsuario"));
        this.hubConnection.invoke("Join", "SuperAdmin", infoUsuario[0].IdTabla);
        clearInterval(this.interval);
      })
      .catch(err => console.log('Error while starting connection: ' + err))

      this.hubConnection.onclose(()=>{
        this.interval = setInterval(this.startConnection, 5000);
        //console.log("se cierra la conexion");
      });
  }

  
 
  public sinalRListener = () => {
    this.hubConnection.on('recibeData', (data) => {
      
      console.log(data);
    });
  }

}
